import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h2 className="PrivacyTitle">PRIVACY POLICY</h2>
      <p>
        At Our Lady of Hope Montessori Schools, we understand the importance of
        protecting the privacy of our users. This Privacy Policy outlines how we
        collect, use, and disclose personal information when you use our
        software. It also outlines your rights and choices regarding your
        personal information.
      </p>
      <h3>Information we collect</h3>
      <p>
        When you use our website or application, we may collect the following
        types of personal information:
      </p>
      <ul>
        <li>
          Account Information: When you create an account, we may collect your
          name, email address, username, and password.
        </li>
        <li>
          Usage Data: We collect information about how you use the application,
          including the features you access, interactions with the application,
          and performance data.
        </li>
        <li>
          Device Information: We may collect information about your mobile
          device, such as device model, operating system version, unique device
          identifiers, and mobile network information.
        </li>
        <li>
          Analytics and Cookies: We use analytics tools and technologies, such
          as cookies, to collect information about your usage patterns and
          improve our application.
        </li>
      </ul>

      <br />

      <h3>Use of Information</h3>
      <p>We use the collected information for the following purposes:</p>
      <ul>
        <li>
          Providing Services: We use your personal information to provide and
          personalize the Montessori learning experience, including tracking
          progress, offering personalized recommendations, and improving our
          application's functionality.
        </li>
        <li>
          Communication: We may use your email address or other contact
          information to send you important updates, newsletters, and
          promotional materials related to the application. You can opt-out of
          receiving promotional communications at any time.
        </li>
        <li>
          Analytics and Improvements: We analyze usage data and other
          information to understand user preferences, improve our application's
          performance and features, and enhance user experience.
        </li>
      </ul>

      <br />

      <h3>Data Sharing and Disclosure</h3>
      <ul>
        <p>
          We do not sell, trade, or otherwise transfer your personal information
          to third parties without your consent, except in the following
          circumstances:
        </p>
        <li>
          Service Providers: We may engage trusted third-party service providers
          who assist us in operating our application and delivering services.
          These providers have access to your personal information only as
          necessary to perform their tasks and are obligated to maintain its
          confidentiality.
        </li>
        <li>
          Legal Compliance: We may disclose your personal information if
          required by law, government request, or to protect our rights,
          property, or safety, or the rights, property, or safety of others.
        </li>
      </ul>

      <br />

      <h3>Data Security</h3>
      <p>
        We implement appropriate technical and organizational measures to
        safeguard your personal information from unauthorized access,
        disclosure, alteration, or destruction. However, please note that no
        method of transmission over the internet or electronic storage is 100%
        secure, and we cannot guarantee absolute security of your data.
      </p>

      <br />

      <h3>Your Rights and Choices</h3>
      <p>
        You have the right to access, update, correct, and delete your personal
        information held by us. You can also exercise certain choices regarding
        the collection and use of your information. For assistance with these
        rights or any privacy-related inquiries, please contact us using the
        information provided below.
      </p>

      <br />

      <h3>Children's Privacy</h3>
      <p>
        Our application is intended for use by children with parental consent.
        We do not knowingly collect personal information from children under the
        age of [insert minimum age requirement] without parental consent. If we
        become aware that we have collected personal information from a child
        without parental consent, we will take steps to remove that information
        from our servers.
      </p>

      <br />

      <h3>Changes to this Privacy Policy</h3>
      <p>
        We may update this Privacy Policy from time to time to reflect changes
        in our privacy practices. We encourage you to review this policy
        periodically for any updates.
      </p>
      <br />
      <h3>Contact Us</h3>
      <p>
        If you have any questions, concerns, or requests regarding this Privacy
        Policy or our privacy practices, please contact us at:
        info@ourladyofhopemontessorischools.com
      </p>
    </div>
  );
}

export default App;
